<template>
    <performance-common-dialog
        :title="'运单明细装车'"
        ref="performanceCommonDialog"
        @close="dialogClose"
        :width="'1300px'"
    >
        <template #top>
            <el-form
                class="form-container"
                ref="formRef"
                label-position="right"
                label-width="69px"
                :model="config.form"
                :rules="config.rules"
            >
                <el-row>
                    <el-col :span="6">
                        <el-form-item label="平台名称：" prop="siteName">
                            <span>{{ componentsModalData.siteName }}</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item
                            label="分公司名称："
                            prop="companyName"
                            label-width="72px"
                        >
                            <span>{{ componentsModalData.companyName }}</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="仓库名称：" prop="whName">
                            <span>{{ componentsModalData.whName }}</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item
                            label="运输单号："
                            prop="taskNo"
                            label-width="65px"
                        >
                            <span>{{ componentsModalData.taskNo }}</span>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="6">
                        <el-form-item label="物流单号：" prop="waybillNo">
                            <span>{{ componentsModalData.waybillNo }}</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item
                            label="运单状态："
                            prop="taskStatusName"
                            label-width="72px"
                        >
                            <span>{{
                                componentsModalData.taskStatusName
                            }}</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="装车时间：" prop="loadDate">
                            <el-date-picker
                                v-model="config.form.loadDate"
                                type="datetime"
                                style="width: 100%"
                                placeholder="选择日期时间"
                            >
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <div class="table-btn">
                        <el-button
                            type="text"
                            @click="taskNoLoading"
                            :loading="loading"
                        >
                            运单装车确认
                        </el-button>
                    </div>
                </el-row>
            </el-form>
        </template>
        <template #table-list>
            <!-- 表格 -->
            <dispatch-waybill-details-load-table
                :componentsModalData="componentsModalData"
            ></dispatch-waybill-details-load-table>
            <!-- 表格 -->
        </template>
    </performance-common-dialog>
</template>
<script>
import dayjs from 'dayjs';
import PerformanceCommonDialog from '@/modules/transport/otp/components/PerformanceCommonDialog';
import DispatchWaybillDetailsLoadTable from './DispatchWaybillDetailsLoadTable';
import { saveTransportLoadInfo } from '@/modules/transport/otp/api/performanceDispatchMgmtNew.js';
import { config } from './config.js';
import { isValidateLoading } from '../dispatchDetailedLoading/util.js';

export default {
    name: 'dispatchDetailedLoading',
    components: { PerformanceCommonDialog, DispatchWaybillDetailsLoadTable },
    props: {
        componentsModalData: {
            type: Object,
            default () {
                return {};
            }
        }
    },
    data () {
        return {
            config: config,
            loading: false,
            totalData: [],
            pageTotal: 0,
            currentPage: 1,
            optionNum: 'SYS_WM_ASN_STATUS,SYS_WM_SO_STATUS'
        };
    },
    mounted () {
        this.$refs.performanceCommonDialog.show();
    },
    methods: {
        /**
         * @description 运单装车
        */
        taskNoLoading () {
            const { loadDate } = this.config.form;
            this.$refs.formRef.validate(async valid => {
                if (!valid) return;
                // 校验装车数量
                const isOk = await isValidateLoading({ taskNo: this.componentsModalData.taskNo });
                if (!isOk) return;
                this.loading = true;
                saveTransportLoadInfo({
                    taskNo: this.componentsModalData.taskNo,
                    loadDate: dayjs(loadDate).format('YYYY-MM-DD HH:mm:ss')
                }).then((res) => {
                    if (res && +res.code === 0) {
                        this.$message.success(res.msg || '操作成功');
                        this.dialogClose();
                    }
                }).finally(() => {
                    this.loading = false;
                });
            });
        },
        dialogClose () {
            this.config.form.loadDate = '';
            this.$emit('components-close');
        }

    }

};
</script>

<style scoped lang="less">
/deep/.el-form-item {
    margin: 0;
    .el-form-item__label {
        padding: 0;
    }
}
/deep/.el-tabs__header {
    margin-bottom: 0px;
}
.table-btn {
    display: flex;
    justify-content: flex-end;
}
/deep/.el-form-item__label {
    color: #999;
}
/deep/.el-form-item__content {
    color: #333;
}
.tms-performance-dialog .main-list-info {
    margin-top: 0px;
    padding-top: 0px;
}
.confirmClass {
    width: 600px;
}
</style>
